import Vue from 'vue'
import App from './App.vue'
import VueMaterial from 'vue-material'
import router from './router'
import store from './store/store'
import axios from 'axios'
import 'vue-material/dist/vue-material.min.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'vue-multiselect/dist/vue-multiselect.min.css'
import AppCSS2 from './assets/app2.scss';
import AppCSS from './assets/app.scss';
import FontRoboto from './assets/font-roboto.scss';
import FontLato from './assets/font/fontLato.css'
import FontKanit from './assets/font/fontKanit.css'
import VueJWT from 'vuejs-jwt'
import Multiselect from 'vue-multiselect'
import Vuelidate from 'vuelidate'
import acl from './acl'
import VueSnackbar from 'vue-snack'
import 'vue-snack/dist/vue-snack.min.css'
import IdleVue from 'idle-vue'
import moment from 'moment-timezone'
import vClickOutside from "v-click-outside";
import i18n, { setLocale } from './i18n';
import appConfig from '@/config/appConfig'

Vue.prototype.$moment = moment

Vue.use(Vuelidate)
Vue.use(VueSnackbar)
Vue.use(VueJWT)
Vue.use(VueMaterial)
Vue.use(Multiselect)
Vue.use(AppCSS2)
Vue.use(AppCSS)
Vue.use(FontRoboto)
Vue.use(FontLato)
Vue.use(VueSweetalert2);
Vue.use(FontKanit)
Vue.use(vClickOutside);

const eventsHub = new Vue()
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 30000
})

Vue.component('multiselect', Multiselect)

Vue.config.productionTip = false

Object.keys(process.env).forEach(function (key) {
    Vue.config[key] = process.env[key];
});

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.config['url'] = process.env.VUE_APP_API_URL;

Vue.prototype.$appConfig = appConfig

// ============================
// โหลด Backend Config ก่อน render
// ============================
// axios.get('/api/config').then(res => {
//     const locale = res.data;
//     setLocale(locale);

//     new Vue({
//         el: '#app',
//         router,
//         store,
//         acl,
//         i18n,
//         render: h => h(App)
//     });
// });
axios.get('/api/config')
    .then(res => {
        Object.assign(appConfig, res.data)
        setLocale(appConfig.locale)
    })
    .catch(() => {
        setLocale('en')
    })
    .finally(() => {
        Vue.prototype.$appConfig = appConfig;

        new Vue({
            el: '#app',
            router,
            store,
            acl,
            i18n,
            render: h => h(App)
        });
    });
